import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import InfoHeader from "../../../comman/infoHeader";
import config from "../../../config.json";
import PageSizeOptions from "../../PageSizeOptions";
import Pagination from "../../../comman/pagination";
import SearchableSelect from "../../../comman/SearchableSelect";
import { paginate, calculateIndex } from "../../../utlis/paginate";
import Moment from "react-moment";
import EditPartner from "./EditPartner";
import ActiveDeactiveHistory from "./ActiveDeactiveHistory";
import Swal from "sweetalert2";
import ReminderAlertMessage from "../../ReminderAlertMessage";
import authService from "../../../services/authService";
import TableLoader from "../../../comman/TableLoader";
import {
  recruitersReceived, loadRecruiters,
  filterRecruitersReceived, loadRecruitersByFilter,
  SendReminder, getReminderStatus, getAllRecruiters, getFilterAllRecruiters,
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
  filterAllRecruiterStatus,
  getFilterRecruiters,
  recCurrentWfTaskReceived,
  receivedRecruiterById,
  getAddedRecPerfromerStatus
} from "../../../app/store/recruiter";
import {
  getCurrentUser,
  getUserProfilePicsById,
  loadUserProfilePicById,
} from "../../../app/store/auth";
import { setCurrentPageTitle, setCurrentRoute } from "../../../app/store/layoutUI";
import { getAlert } from "../../../services/appAlerts";
import { getFieldData, getFormatedNumber } from "../../../services/appService";
import Document from "../../PortalForms/Document";
import WorkflowElement from "../../../app/components/WorkflowElement";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived, loadDocuments, loadReqDocuments, getDocuments, getReqDocuments } from "../../../app/store/documents";
import { receivedSubcontractorById, subsCurrentWfTaskReceived } from "../../../app/store/subcontractor";
import { formLibraryReceived } from "../../../app/store/forms";
import AchInformation from "../../../ReviewTools/AchInformation";
import InsuranseInformation from "../../../ReviewTools/InsuranseInformation";
import { candidateAppsReceived, receivedCandidateById } from "../../../app/store/candidate";
import { getRecruiterPartners, loadRecruiterPartners } from "../../../app/store/partner";
import ViewCandidate from "../../OMCRegistry/ViewCandidate";

const getTwoLetterInitials = (name, fallback = "RC") => {
  if (!name || !name.trim()) return fallback;
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }
  return name.trim().substring(0, 2).toUpperCase();
};

const KeyContactAvatar = ({ contact }) => {
  const dispatch = useDispatch();
  const profilePicsByUserId = useSelector(getUserProfilePicsById);
  const [imageFailed, setImageFailed] = useState(false);
  const performerId = contact?.performerid;
  const hasProfilePic = performerId
    ? Object.prototype.hasOwnProperty.call(profilePicsByUserId, performerId)
    : false;
  const profilePic = performerId ? profilePicsByUserId[performerId] : null;
  const contactName = [contact?.performername, contact?.lastName]
    .filter(Boolean)
    .join(" ");

  useEffect(() => {
    setImageFailed(false);
    if (performerId && !hasProfilePic) {
      dispatch(loadUserProfilePicById(performerId));
    }
  }, [dispatch, performerId, hasProfilePic]);

  const imageUrl = profilePic
    ? `${process.env.REACT_APP_API_BASEURL}/ProfilePics/${profilePic}`
    : null;

  return (
    <div className="wf-avatar-circle" title={contactName || "Key contact"}>
      {imageUrl && !imageFailed ? (
        <img
          className="wf-avatar-image"
          src={imageUrl}
          alt={contactName ? `${contactName} profile` : "Key contact profile"}
          onError={() => setImageFailed(true)}
        />
      ) : (
        getTwoLetterInitials(contactName)
      )}
    </div>
  );
};

export default function ListRecruiter() {

  let route = [
    { url: "", name: "System Administration" },
    { url: "", name: "Manage Partners" },
  ];

  const param = useParams();
  const type = param?.type;

  if (type === "partner") {
    route = [
      { name: "System Administration", url: "" },
      { name: "Manage Entities", url: "" },
    ];
  } else {
    route = [
      { name: "Onboarding and Contracts", url: "" },
    ];
  }

  const currentUser = getCurrentUser();

  const [partnerType, setPartnerType] = useState("Recruiter");
  const [actionType, setActionType] = useState("action");
  const [recruiters, setRecruiters] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);

  const location = useLocation();
  const candidateListLink = location.state?.fromCandidateList ? location.state : null;
  const restoredCandidateList = location.state?.restoreCandidateList
    ? (location.state.candidateListState || { currentPage: 1, pageSize: 5, dataType: "" })
    : null;

  const [currentPage, setCurrentPage] = useState(restoredCandidateList ? restoredCandidateList.currentPage : 1);
  const [pageSize, setPageSize] = useState(restoredCandidateList ? restoredCandidateList.pageSize : 5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState("");
  const [recId, setRecId] = useState("");
  const [recruiterId, setRecruiterId] = useState("");
  const [recName, setRecName] = useState("");
  const [recEmail, setRecEmail] = useState("");
  const [dataType, setDataType] = useState("");
  const [selectedRecruiterId, setSelectedRecruiterId] = useState(0);
  const [selectedTab, setSelectedTab] = useState("home");

  const [viewRowType, setViewRowType] = useState("");
  const [selectedKey, setSelectedKey] = useState(-1);
  const [selectedFormKey, setSelectedFormKey] = useState(-1);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");

  const [achType, setAchType] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [selectedInfo, setSelectedInfo] = useState("");
  const [editDurType, setEditDurType] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

  const [filterShowHide, setFilterShowHide] = useState(false);
  const [isFilterApplying, setIsFilterApplying] = useState(false);
  const [filterRecruiterList, setFilterRecruiterList] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(true);

  const allRecruiters = useSelector(getAllRecruiters);
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const remiderStatus = useSelector(getReminderStatus);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const recruiterFilterData = useSelector(getFilterRecruiters)
  const recruiterPartnersSelector = useSelector(getRecruiterPartners);
  const storeLoading = useSelector(getAddedRecPerfromerStatus);
  const isLoading = storeLoading || isTableLoading;

  const appDocumentSelector = useSelector(getDocuments);
  const reqDocumentsSelector = useSelector(getReqDocuments);

  const getDocsCountForApp = (applicantObj, appDocSelector, reqDocSelector) => {
    if (!applicantObj) return 0;

    const appDocs = (appDocSelector || []).filter((x) => {
      const uploadType = (x.uploadType || "").toLowerCase();
      const updType = (x.updType || "").toLowerCase();
      const isAch =
        uploadType.startsWith("ach_") ||
        updType.startsWith("ach_") ||
        /ach_\d+/i.test(uploadType) ||
        /ach_\d+/i.test(updType);
      const isInsurance =
        uploadType.startsWith("insurance_") ||
        updType.startsWith("insurance_");

      return x.uploadType !== "req" && !isInsurance && !isAch;
    });
    const reqDocs = reqDocSelector || [];

    const filterDocs = appDocs.filter(
      (x) => x.updType !== "Messaging" && x.deleteFlag !== true
    );

    let sentDocuments = [];
    let filterReqDocs = [];

    if (applicantObj?.recruiter?.parentid > 0) {
      sentDocuments = filterDocs.filter(
        (x) =>
          x.deleteFlag !== true &&
          x.uploaderId !== applicantObj?.recruiter?.parentid &&
          x.uploaderId !== applicantObj?.id &&
          x.receiverId !== applicantObj?.id
      );

      filterReqDocs = reqDocs.filter(
        (x) => x.performerId === applicantObj?.recruiter?.parentid
      );
    } else {
      sentDocuments = filterDocs.filter(
        (x) => x.deleteFlag !== true && x.uploaderId !== applicantObj?.id
      );

      filterReqDocs = reqDocs.filter(
        (x) => x.performerId === applicantObj?.id
      );
    }

    const sentCount = sentDocuments.filter(
      (x) =>
        x.uploadType !== "client" &&
        x.uploadType !== "reporting" &&
        x.uploadType !== "project" &&
        x.uploadType !== "agency" &&
        x.uploadType !== "msp" &&
        x.uploadType !== "ProjectInfo" &&
        x.updType !== "internal" &&
        x.updType !== "Invoice" &&
        !(x.updType && x.updType.includes("req_"))
    ).length;

    const reqCount = filterReqDocs.length;

    return sentCount + reqCount;
  };

  const docsCount = getDocsCountForApp(selectedObj, appDocumentSelector, reqDocumentsSelector);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const didSkipInitialRecruiters = useRef(false);
  const isInitiallyLoaded = useRef(false);

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Recruiters"))
    dispatch(loadRecruiterPartners("Recruiter"));

    if (restoredCandidateList) {
      setDataType(restoredCandidateList.dataType || "");
      isInitiallyLoaded.current = true;
      if (restoredCandidateList.dataType !== "filter") {
        dispatch(loadRecruiters(restoredCandidateList.pageSize, restoredCandidateList.currentPage, partnerType));
      }
    }
  }, []);

  useEffect(() => {
    const autoFilter = candidateListLink?.partnerListFilter;
    if (!autoFilter) return;

    setDataType("filter");
    setRecId(autoFilter.id || "");
    setRecName(autoFilter.name || "");
    setRecEmail(autoFilter.email || "");
    setIsTableLoading(true);
    isInitiallyLoaded.current = true;

    const frmBody = new FormData();
    frmBody.append("id", autoFilter.id || "");
    frmBody.append("name", autoFilter.name || "");
    frmBody.append("email", autoFilter.email || "");
    frmBody.append("type", partnerType || "");
    dispatch(loadRecruitersByFilter(frmBody));
    dispatch(filterAllRecruiterStatus({
      id: autoFilter.id || "",
      name: autoFilter.name || "",
      email: autoFilter.email || "",
      dataType: "filter",
    }));
  }, []);

  useEffect(() => {
    if (!candidateListLink && recruiterFilterData?.dataType === "filter" && dataType !== "filter") {
      setRecId("");
      setRecruiterId("");
      setRecName("");
      setRecEmail("");
      dispatch(filterAllRecruiterStatus(""));

      if (!isInitiallyLoaded.current) {
        setIsTableLoading(true);
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
        isInitiallyLoaded.current = true;
      }

      return;
    }

    if (recruiterFilterData === "" && selectedTab === "home") {
      if (!isInitiallyLoaded.current) {
        setIsTableLoading(true);
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
        isInitiallyLoaded.current = true;
      }
    } else if (recruiterFilterData.dataType === "filter") {
      // console.log("recruiterFilterData", recruiterFilterData)
      setRecId(recruiterFilterData.id);
      setRecName(recruiterFilterData.name);
      setRecEmail(recruiterFilterData.entity);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (!didSkipInitialRecruiters.current) {
      didSkipInitialRecruiters.current = true;
      return;
    }

    setRowsCount(allRecruiters.length > 0 ? allRecruiters[0].totalPartners : 0);
    setRecruiters(allRecruiters);
    setIsTableLoading(false);
    handleCloseDocumentView();
  }, [allRecruiters]);

  useEffect(() => {
    if (dataType !== "filter") return;
    setCurrentPage(1);
    setPageSize(5)
    getPagedData(filterAllRecruiters, 1, 5);
    setIsTableLoading(false);
  }, [filterAllRecruiters]);

  useEffect(() => {
    // dispatch(loadAppDefaultData(1));
    setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
    dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
  }, []);

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    if (selectedTab === "onboardingForm" && selectedObj) {
      setWfForm(null);
      let appCiid = 0;
      if (selectedObj.applications?.length > 0) {
        const allWfTasks = selectedObj.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
        setUpdatedStateData(selectedObj.applications[0].applicationData);
      } else {
        setUpdatedStateData(selectedObj.contact1?.performerData || selectedObj.contact1?.performerdata || "");
      }
      setWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
    }
  }, [selectedObj, selectedTab, dispatch]);

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllRecruiters, currentPage, pageSize);
      else {
        setIsTableLoading(true);
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
      }
    }
  }, [remiderStatus])

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    handleResetSelection();
    if (dataType === "filter")
      getPagedData(filterAllRecruiters, page, pageSize)
    else {
      setIsTableLoading(true);
      dispatch(loadRecruiters(pageSize, page, partnerType));
    }
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    handleResetSelection();
    if (dataType === "filter")
      getPagedData(filterAllRecruiters, currentPage, currentTarget.value);
    else {
      setIsTableLoading(true);
      dispatch(loadRecruiters(currentTarget.value, currentPage, partnerType));
    }
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalPartners);
    else
      setRowsCount(0);

    setRecruiters(items);
    setIsTableLoading(false);
    handleCloseDocumentView();
  };

  useEffect(() => {
    setFilterRecruiterList(recruiterPartnersSelector);
  }, [recruiterPartnersSelector])

  const handleModalShowHide = (item) => {
    setShowHide(!showHide);
    setSelectedObj(item);
  };

  const handleAddEditRecruiter = (data, isChanged = false) => {
    if (data === "exit") {
      if (isChanged) {
        setTimeout(() => {
          if (dataType === "filter")
            getPagedData(filterAllRecruiters, currentPage, pageSize);
          else {
            setIsTableLoading(true);
            dispatch(loadRecruiters(pageSize, currentPage, partnerType));
          }
        }, 3000);
      }

      setSelectedTab("home");
      setSelectedObj("");
      setSelectedRecruiterId(0);
    }
  };

  const handleTabOnSelect = (tab) => {
    setSelectedTab(tab);
    if (tab === "home") {
      setSelectedKey(-1);
      setSelectedFormKey(-1);
    }
  };

  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (dataType === "filter")
        getPagedData(filterAllRecruiters, currentPage, pageSize);
      else {
        setIsTableLoading(true);
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
      }
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handleFilter = async () => {
    setIsFilterApplying(true);
    handleResetSelection();
    setDataType("filter");
    var frmBody = new FormData();
    frmBody.append("id", recId || "");
    if (recruiterId && !recId)
      frmBody.append("id", recruiterId);

    frmBody.append("name", recName || "");
    frmBody.append("email", recEmail || "");
    frmBody.append("type", partnerType || "");
    setIsTableLoading(true);
    try {
      await dispatch(loadRecruitersByFilter(frmBody));
      dispatch(filterAllRecruiterStatus({
        "id": recId,
        "name": recName,
        "email": recEmail,
        "dataType": "filter",
      }));
    } finally {
      setIsFilterApplying(false);
    }
  };

  const handleRefresh = () => {
    recruiters.forEach((recruiter) => {
      const keyContactId = recruiter?.contact1?.performerid;
      if (keyContactId) {
        dispatch(loadUserProfilePicById(keyContactId, true));
      }
    });

    if (dataType === "filter") handleFilter();
    else {
      setIsTableLoading(true);
      dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    }
  };

  const handleFilterCancel = (type) => {
    if (type === "close" && filterShowHide)
      setFilterShowHide(false);
    setDataType("");
    setRecId("");
    setRecName("");
    setRecEmail("");
    setCurrentPage(1);
    setPageSize(5)
    setRecruiterId("")
    setIsTableLoading(true);
    dispatch(loadRecruiters(5, 1, partnerType))
    dispatch(filterAllRecruiterStatus(""))
  };

  const handlePartnerPerformer = () => {
    if (selectedRecruiterId > 0) {
      navigate("/ManagePartnerPerformer", {
        state: {
          obj: selectedObj,
          partner: "Recruiters",
          url: "Recruiter/partner",
        }
      })
    }

  }

  const getLastWorkflowTask = (workflowTasks) => {
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handlePartnerApplication = (item, app) => {
    // navigate("/CustomerApps", {
    //   state: {
    //     item: item,
    //     currentUser: currentUser,
    //     type: type,
    //     selectedApp: app.applicationId,
    //     appType: "partner",
    //     module: "Recruiter",
    //   }
    // })
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "partner",
        module: "Recruiter",
        returnTo: `/Recruiter/${type || "application"}`,
        candidateListState: {
          currentPage,
          pageSize,
          dataType,
        },
      }
    })
  }

  const handleSelectRecruiter = (item, forceSelect = false) => {
    if (!forceSelect && selectedRecruiterId === item.fuid) {
      handleResetSelection();
      return;
    }

    setSelectedRecruiterId(item.fuid);
    setSelectedObj(item);

    if (item?.applications?.length > 0) {
      const app = item.applications[0];
      setSelectedApp(app);
      const task = getLastWorkflowTask(app?.workflowTasks || []);
      setSelectedCurrentTask(task);
      if (task?.ciid > 0) {
        dispatch(loadDocuments(task.ciid));
        dispatch(loadReqDocuments(task.ciid));
      }
    } else {
      setSelectedApp(null);
      setSelectedCurrentTask(null);
    }
  }

  useEffect(() => {
    const autoFilterId = candidateListLink?.partnerListFilter?.id;
    if (!autoFilterId || recruiters.length === 0) return;

    const matchedRecruiter = recruiters.find(
      (item) => String(item.fuid) === String(autoFilterId),
    );

    if (matchedRecruiter && selectedRecruiterId !== matchedRecruiter.fuid) {
      handleSelectRecruiter(matchedRecruiter, true);
    }
  }, [recruiters, candidateListLink, selectedRecruiterId]);

  const handleResetSelection = () => {
    setSelectedRecruiterId(0);
    setSelectedObj(null);
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    setSelectedKey(-1);
    setSelectedFormKey(-1);
    setViewRowType("");
    setSelectedInfo("");
    setAchType("");
    setInsuranceType("");
    if (["contracts", "ach", "insurance", "onboardingForm"].includes(selectedTab)) {
      setSelectedTab("home");
    }
    dispatch(documentReceived([]));
    dispatch(reqDocumentReceived([]));
  }

  const handlePermissionShowHide = () => {
    handleResetSelection()
    setSelectedTab("home");
  };

  const handlePermissionShowHide2 = () => {
    setIsTableLoading(true);
    dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    setSelectedTab("home");
  };

  const handleDocumentViewShowHide = (type, key, app) => {
    handleCloseDocumentView();
    setViewRowType(type);
    setSelectedInfo(type);
    setSelectedKey(key);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  };

  const handleCloseDocumentView = () => {
    console.log("recruiterlist")
    setSelectedFormKey(-1);
    setViewFormType("");
    setUpdatedStateData("");
    setSelectedKey(-1);
    setViewRowType("");
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    setWfTask(null);
    setWfForm(null);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(candidateAppsReceived([]))
  }

  const handleViewRecruiterForm = (type, key, item) => {
    setSelectedKey(-1)
    setViewRowType("");
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    if (viewFormType === type) {
      setViewFormType("");
      setSelectedFormKey(-1);
      setUpdatedStateData();
      setWfTask(null);
      setWfForm(null);
    } else {
      setViewFormType(type);
      setSelectedFormKey(key);
      let appCiid = 0;
      if (item.applications?.length > 0) {
        const allWfTasks = item.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
        setUpdatedStateData(item.applications[0].applicationData);
      } else {
        setUpdatedStateData(item.contact1.performerData);
      }
      setWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
    }
  }

  const handleNextTask = () => {
    console.log("")
  }

  const handleACHShowHide = (mod, type, item, key, app) => {
    console.log("recruiterlist")
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType(type);
    setInsuranceType("");
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const handleInsuranceShowHide = (mod, type, item, key, app) => {
    console.log("recruiterlist")
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType("");
    setInsuranceType(type);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const closeACHInsu = () => {
    setSelectedInfo("");
    setSelectedKey(-1);
    setAchType("");
    setInsuranceType("");
    dispatch(receivedRecruiterById([]));
  }

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    if (!filterShowHide) {
      if (recruiterPartnersSelector.length === 0)
        dispatch(loadRecruiterPartners("Recruiter"));
    }
  }

  const getInitial = (name) => {
    return getTwoLetterInitials(name);
  };

  const getContactName = (contact) => {
    if (!contact) return "No contact assigned";
    const name = [contact.performername, contact.lastName].filter(Boolean).join(" ");
    return name || "No contact assigned";
  };

  const getContactEmail = (item) =>
    type === "application" ? item?.email : item?.contact1?.performeremail;

  const getActivationStatus = (contact) => {
    if (contact?.isActive === true) {
      return {
        label: "Activated",
        icon: "fa-check-circle",
        className: "is-complete",
      };
    }
    if (contact?.isActive === false) {
      return {
        label: "Deactivated",
        icon: "fa-times-circle",
        className: "is-danger",
      };
    }
    return { label: "To activate", icon: "fa-clock-o", className: "is-muted" };
  };

  const getAddressLines = (item) => {
    const firstLine = item?.accessKey || "";
    const secondLine = [item?.portalUrl, item?.city, item?.state, item?.zip]
      .filter(Boolean)
      .join(", ");

    return [firstLine, secondLine].filter(Boolean);
  };

  return (
    <React.Fragment>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0% { width: 0%; opacity: 1; }
          70% { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long { width: 85%; }
        .skeleton-cell.sk-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          flex: 0 0 auto;
        }

        .skeleton-row td {
          padding: 14px 16px !important;
        }

        .skeleton-identity {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }

        .skeleton-stack {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
        }

        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          overflow: hidden !important;
          position: relative !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          font-size: 14px !important;
        }

        .wf-card-header-bar {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: #ffffff !important;
          border-radius: 0 !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: transparent;
          border: 1px solid rgba(100, 116, 139, 0.18);
          color: #1e293b;
          border-radius: 0;
          padding: 5px 12px;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.2px;
        }

        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }

        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }

        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }

        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: #ffffff !important;
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-header-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: rgba(37, 99, 235, 0.07);
          border: 1px solid rgba(37, 99, 235, 0.15);
          color: #1d4ed8;
          border-radius: 0;
          padding: 3px 10px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .search-panel-collapse input,
        .search-panel-collapse textarea,
        .search-panel-collapse select {
          font-weight: 400 !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226, 232, 240, 0.7);
          background: #ffffff;
        }

        .wf-control-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 12px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 0 !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .list-recruiter-page .search-panel-collapse .wf-input-wrap > input.form-control.wf-input {
          padding: 0 14px !important;
          padding-left: 14px !important;
          padding-inline-start: 14px !important;
          text-indent: 0 !important;
          text-align: left !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }

        .wf-select {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
          padding-right: 36px !important;
        }

        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          border-bottom: 2px solid #e5e5e5 !important;
          margin-bottom: 0 !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          flex: 0 0 auto !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 14px !important;
          color: currentColor !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff !important;
          background: #171717 !important;
        }

        .wf-tab-btn.active i {
          color: #ffffff !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #171717 !important;
          border-radius: 2px 2px 0 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0) !important;
        }

        .wf-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border-radius: 999px !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          background: #f1f5f9 !important;
          color: #64748b !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          line-height: 1 !important;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        .wf-tab-btn.tab-locked .wf-tab-badge {
          background: rgba(245,158,11,0.1);
          color: #b45309;
          border-color: rgba(245,158,11,0.2);
        }

        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        body.workflow-user-card-scroll #layout-scroll-wrapper {
          overflow-y: auto !important;
        }

        body.workflow-user-card-scroll .modern-breadcrumb-container {
          margin-bottom: 10px !important;
        }

        .wf-main-card > .card-body:not(.wf-tabs-container) {
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        .wf-tab-panel::-webkit-scrollbar,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-tab-panel::-webkit-scrollbar-track,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb:hover,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        .wf-table-scroll {
          width: 100% !important;
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
        }

        .wf-table-modern {
          width: 100% !important;
          min-width: 0 !important;
          table-layout: fixed !important;
          border-collapse: collapse !important;
          border-spacing: 0 !important;
          background: #ffffff !important;
          border: none !important;
          border-radius: 0 !important;
        }

        .wf-table-modern .wf-thead {
          background: #f8fafc !important;
        }

        .wf-table-modern .wf-thead th {
          padding: 12px 14px !important;
          border-bottom: 1px solid #e5e7eb !important;
          color: #64748b !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          letter-spacing: 0.04em !important;
          text-transform: uppercase !important;
          white-space: normal !important;
        }

        .wf-table-modern td {
          padding: 12px 14px !important;
          border-bottom: 1px solid #eef2f7 !important;
          vertical-align: top !important;
          color: #334155 !important;
          font-size: 13.5px !important;
          overflow-wrap: anywhere !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease !important;
        }

        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
          box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
        }

        .wf-table-row.selected-row {
          background: linear-gradient(90deg, rgba(37,99,235,0.07) 0%, rgba(37,99,235,0.02) 100%) !important;
          box-shadow: inset 4px 0 0 0 #2563eb !important;
        }

        .wf-table-application th:nth-child(1),
        .wf-table-application td:nth-child(1) { width: 25% !important; }
        .wf-table-application th:nth-child(2),
        .wf-table-application td:nth-child(2) { width: 25% !important; }
        .wf-table-application th:nth-child(3),
        .wf-table-application td:nth-child(3) { width: 25% !important; }
        .wf-table-application th:nth-child(4),
        .wf-table-application td:nth-child(4) { width: 25% !important; }

        .wf-table-partner th:nth-child(1),
        .wf-table-partner td:nth-child(1) { width: 25% !important; }
        .wf-table-partner th:nth-child(2),
        .wf-table-partner td:nth-child(2) { width: 35% !important; }
        .wf-table-partner th:nth-child(3),
        .wf-table-partner td:nth-child(3) { width: 15% !important; }
        .wf-table-partner th:nth-child(4),
        .wf-table-partner td:nth-child(4) { width: 10% !important; }
        .wf-table-partner th:nth-child(5),
        .wf-table-partner td:nth-child(5) { width: 15% !important; }

        .wf-table-application td:nth-child(3),
        .wf-table-partner td:nth-child(2) {
          text-align: left !important;
          vertical-align: top !important;
        }

        @media (max-width: 1199px) {
          .wf-table-scroll {
            overflow-x: auto !important;
            overflow-y: visible !important;
          }

          .wf-table-modern {
            min-width: 1120px !important;
          }
        }

        .wf-identity-cell {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          min-width: 0;
        }

        .wf-avatar-stack {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          flex: 0 0 auto;
          position: relative;
        }

        .wf-avatar-circle {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          color: #ffffff;
          font-weight: 600;
          box-shadow: 0 3px 10px rgba(15, 23, 42, 0.18);
          overflow: hidden;
        }

        .wf-avatar-image {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }

        .wf-avatar-check-badge {
          position: absolute;
          right: -4px;
          top: -4px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #2563eb;
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 9px;
          border: 2px solid #ffffff;
          box-shadow: 0 2px 6px rgba(37,99,235,0.25);
        }

        .wf-inline-id,
        .wf-id-pill,
        .wf-count-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          width: max-content;
          border: 1px solid #dbe3ef;
          background: #eff6ff;
          color: #2563eb;
          border-radius: 6px;
          padding: 3px 7px;
          font-size: 11px;
          font-weight: 600;
          line-height: 1;
        }

        .wf-count-pill {
          background: #ecfdf5;
          border-color: #bbf7d0;
          color: #047857;
        }

        .wf-identity-copy,
        .wf-contact-card,
        .wf-status-stack,
        .wf-activation-stack {
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 0;
        }

        .wf-identity-title,
        .wf-contact-name {
          color: #0f172a !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          line-height: 1.3 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          white-space: normal !important;
          word-break: break-word !important;
        }

        .wf-identity-meta-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: #475569;
          font-size: 12.5px;
          line-height: 1.4;
        }

        .wf-identity-meta-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 5px;
          background: #eff6ff;
          color: #2563eb;
          font-size: 10px;
          flex-shrink: 0;
        }

        .wf-icon-calendar { background: #faf5ff; color: #7c3aed; }
        .wf-icon-address { background: #fff1f2; color: #e11d48; }
        .wf-icon-user { background: #ecfdf5; color: #059669; }
        .wf-icon-phone { background: #fff7ed; color: #ea580c; }

        .wf-identity-address-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .wf-app-list {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          text-align: left !important;
          gap: 10px;
          width: 100%;
        }

        .wf-app-name-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.02) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          flex-wrap: nowrap !important;
          width: 100%;
          box-sizing: border-box;
          cursor: pointer !important;
        }

        .wf-app-name-card:hover {
          border-color: #2563eb !important;
          box-shadow: 0 4px 16px -4px rgba(37, 99, 235, 0.15) !important;
          transform: translateY(-1px) !important;
          background: #fafbff !important;
        }

        .wf-app-actions-card {
          background: #ffffff !important;
          border: 1px solid #eef2f6 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          flex-direction: column;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          text-align: left !important;
          gap: 8px;
          width: 100%;
          box-sizing: border-box;
        }

        .wf-app-actions-card:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px) !important;
        }

        .wf-app-header-left {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
          flex: 1;
        }

        .wf-app-icon-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 8px;
          background: #eff6ff;
          color: #2563eb;
          flex-shrink: 0;
        }

        .wf-app-title-text {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #0f172a;
          font-weight: 600;
        }

        .wf-app-id-text {
          color: #94a3b8;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 3px 7px;
          font-size: 11px;
          font-weight: 600;
          flex-shrink: 0;
        }

        .wf-status-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          width: max-content;
          border-radius: 0 !important;
          padding: 4px 9px;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .wf-app-status-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 22px;
          min-width: 82px;
          padding: 0 8px;
          border-radius: 0 !important;
          font-size: 9.5px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border: 1px solid transparent;
          white-space: nowrap !important;
          flex-shrink: 0;
        }

        .wf-status-pill.is-complete {
          background: #ecfdf5;
          border: 1px solid #bbf7d0;
          color: #047857;
        }

        .wf-status-pill.is-pending {
          background: #fff7ed;
          border: 1px solid #fed7aa;
          color: #c2410c;
        }

        .wf-app-status-badge.is-complete {
          background: #2dce898c;
          border: 1px solid #2dce89;
          color: #000000;
        }

        .wf-app-status-badge.is-review {
          background: var(--yellow);
          border: 1px solid #e6c000;
          color: #000000;
        }

        .wf-status-pill.is-danger {
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #b91c1c;
        }

        .wf-status-pill.is-muted {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #64748b;
        }

        .wf-action-stack {
          display: flex !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          flex-wrap: wrap;
          gap: 6px;
          text-align: left !important;
        }

        .wf-row-actions {
          display: flex;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 6px !important;
        }

        .wf-row-actions button.wf-subcontractor-link-btn,
        .wf-activation-stack button.wf-subcontractor-link-btn {
          height: auto !important;
          min-height: unset !important;
          padding: 0 !important;
          border: none !important;
          background: transparent !important;
          box-shadow: none !important;
          line-height: 1.5 !important;
          transform: none !important;
        }

        .wf-table i,
        .wf-table-modern i,
        .wf-status-pill i,
        .wf-app-status-badge i,
        .wf-link-action i,
        .btn-action-search i {
          display: inline-block !important;
          font-family: FontAwesome !important;
          font-style: normal !important;
          font-weight: normal !important;
          color: currentColor !important;
          visibility: visible !important;
          opacity: 1 !important;
        }

        .wf-link-action,
        .wf-review-btn,
        .wf-tool-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: 1px solid #dbe3ef;
          border-radius: 8px;
          background: #ffffff;
          color: #334155;
          font-size: 12px;
          font-weight: 600;
          transition: all 0.18s ease;
          cursor: pointer;
          white-space: nowrap;
        }

        .wf-link-action {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
          font-weight: 600 !important;
          padding: 6px 10px !important;
          font-size: 11.5px !important;
        }

        .wf-link-action:hover {
          background: #dbeafe !important;
          border-color: #93c5fd !important;
          color: #1e40af !important;
        }

        .wf-link-action:hover,
        .wf-review-btn:hover,
        .wf-tool-btn:hover {
          background: #f8fafc;
          border-color: #bfdbfe;
          color: #1d4ed8;
          transform: translateY(-1px);
        }

        .wf-tool-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          border-radius: 999px;
          background: #dc2626;
          color: #ffffff;
          font-size: 10px;
          font-weight: 600;
        }

        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 20px;
          color: #64748b;
          text-align: center;
        }

        .wf-empty-title {
          margin: 8px 0 4px;
          color: #0f172a;
          font-weight: 600;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(15,118,110,0.06) 100%);
          color: #2563eb;
          border: 1px solid rgba(37,99,235,0.12);
        }

        .wf-empty-desc {
          font-size: 13px;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          text-align: center;
          width: 100%;
        }

        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Assign card */
        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 14px;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: searchSlideDown 0.3s ease both;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          height: auto !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-assign-actions .btn-danger-search {
          padding: 8px 12px !important;
          min-width: 38px !important;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          flex-shrink: 0;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 3px;
        }

        .wf-assign-meta span {
          display: inline-flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          font-size: 12px;
          color: #64748b;
          font-weight: 600;
        }

        .wf-reset-selection {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          margin-left: 6px;
          border: 1px solid #dbe3ef;
          border-radius: 7px;
          background: #ffffff;
          color: #2563eb;
          cursor: pointer;
          transition: all 0.18s ease;
        }

        .wf-reset-selection:hover {
          background: #eff6ff;
          border-color: #bfdbfe;
        }

      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card list-subcontractor-page list-recruiter-page">
          {isLoading && <div className="wf-loading-bar" />}
          <div className="wf-card-header-bar">
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                <span>{rowsCount} Recruiters</span>
              </span>
            </div>
            <div>
              {candidateListLink && (
                <button
                  className="btn-action-search"
                  onClick={() => navigate(
                    candidateListLink.returnTo || "/ListCondidate/application",
                    {
                      state: {
                        restoreCandidateList: true,
                        candidateListState: candidateListLink.candidateListState,
                      },
                    },
                  )}
                  style={{ marginRight: 8 }}
                >
                  <i className="fa fa-arrow-left" /> Back to Candidates
                </button>
              )}
              <button
                className="btn-search-trigger"
                onClick={handleSearchShowHide}
              >
                <i
                  className={`fa ${filterShowHide ? "fa-times" : "fa-filter"}`}
                  aria-hidden="true"
                />{" "}
                {filterShowHide ? "Close Filters" : "Filters"}
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Reload recruiters"
                style={{ marginLeft: 8 }}
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>
          {filterShowHide && (
            <div className="px-3 mt-2">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Recruiters
                  </span>
                  <span className="sp-header-badge">
                    <i className="fa fa-filter" /> Advanced Search
                  </span>
                </div>

                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="recId" className="wf-control-label">
                        <i className="fa fa-hashtag" /> ID
                      </label>
                      <div className="wf-input-wrap">
                        <input
                          type="text"
                          name="recId"
                          id="recId"
                          className="form-control wf-input"
                          placeholder="ID"
                          value={recId}
                          onChange={({ currentTarget }) =>
                            setRecId(currentTarget.value)
                          }
                          onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-5 form-group mb-3">
                      <label
                        htmlFor="recruiterId"
                        className="wf-control-label"
                      >
                        <i className="fa fa-handshake-o" /> Recruiter
                      </label>
                      <SearchableSelect
                        id="recruiterId"
                        name="recruiterId"
                        placeholder="Select Recruiter"
                        valuePaddingLeft={14}
                        value={recruiterId}
                        onChange={setRecruiterId}
                        options={(filterRecruiterList || []).map((item) => ({
                          value: item.fuid,
                          label: `${item.label} - ${item.fuid}`,
                        }))}
                      />
                    </div>

                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="recEmail" className="wf-control-label">
                        <i className="fa fa-envelope" /> Email
                      </label>
                      <div className="wf-input-wrap">
                        <input
                          type="text"
                          name="recEmail"
                          id="recEmail"
                          className="form-control wf-input"
                          placeholder="Email"
                          value={recEmail}
                          onChange={({ currentTarget }) =>
                            setRecEmail(currentTarget.value)
                          }
                          onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    onClick={() => handleFilterCancel("close")}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={() => handleFilterCancel("refresh")}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter()}
                    disabled={isFilterApplying || (!recId?.trim() && !recruiterId && !recEmail?.trim())}
                  >
                    {isFilterApplying ? (
                      <><i className="fa fa-spinner fa-spin" aria-hidden="true" /> Applying...</>
                    ) : (
                      <><i className="fa fa-search" aria-hidden="true" /> Apply Filters</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="card-body px-3 pt-2 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedTab === "home" ? " active" : ""}`}
                onClick={() => handleTabOnSelect("home")}
              >
                <i className="fa fa-list-alt" />
                Recruiters
                <span className="wf-tab-badge">
                  {recruiters.length > 0 ? rowsCount : "—"}
                </span>
              </button>

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "addEditRecruiter" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("addEditRecruiter")}
                >
                  <i className={`fa ${selectedRecruiterId === 0 ? "fa-plus-circle" : "fa-edit"}`} />
                  {selectedRecruiterId === 0 ? "Add" : "Edit"} Recruiter
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "contracts" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("contracts")}
                >
                  <i className="fa fa-file-text-o" />
                  Contract Documents
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {docsCount}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "ach" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("ach")}
                >
                  <i className="fa fa-bank" />
                  ACH Information
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {selectedApp?.achRequest || 0}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "insurance" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("insurance")}
                >
                  <i className="fa fa-shield" />
                  Insurance Information
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {selectedApp?.insuranceRequest || 0}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "onboardingForm" ? " active" : ""}`}
                  onClick={() => {
                    if (selectedRecruiterId > 0 && selectedObj) {
                      const idx = recruiters.findIndex(r => r.fuid === selectedObj.fuid);
                      handleViewRecruiterForm("Recruiter", idx, selectedObj);
                    }
                    handleTabOnSelect("onboardingForm");
                  }}
                >
                  <i className="fa fa-list-alt" />
                  Onboarding Form
                </button>
              )}

              {type === "partner" && (
                <button
                  className={`wf-tab-btn${selectedTab === "status" ? " active" : ""}${selectedRecruiterId === 0 ? " tab-locked" : ""}`}
                  onClick={() => handleTabOnSelect("status")}
                >
                  <i className="fa fa-toggle-on" />
                  Activate/Deactivate
                </button>
              )}

              {type === "partner" && (
                <button
                  className={`wf-tab-btn${selectedTab === "users" ? " active" : ""}${selectedRecruiterId === 0 ? " tab-locked" : ""}`}
                  onClick={() => {
                    if (selectedRecruiterId > 0) {
                      handlePartnerPerformer();
                    } else {
                      handleTabOnSelect("users");
                    }
                  }}
                >
                  <i className="fa fa-user-plus" />
                  Assign/Manage Users
                </button>
              )}
            </div>

            <div className="wf-tab-panel">
              {selectedTab === "home" && (
                <div className="mt-2">
                  {/* Selected recruiter context card */}
                  {selectedRecruiterId > 0 && selectedObj && (
                    <div
                      className="wf-assign-card"
                      style={{ marginTop: 8, marginBottom: 14 }}
                    >
                      <div className="wf-assign-info">
                        <div className="wf-assign-avatar">
                          {getInitial(selectedObj.label)}
                        </div>
                        <div className="wf-assign-meta">
                          <strong>
                            {selectedObj.label || "Recruiter"}
                          </strong>
                          <span>
                            <i
                              className="fa fa-hashtag"
                              style={{ marginRight: 4 }}
                            />
                            ID: #{selectedObj.fuid}
                            &nbsp;&bull;&nbsp;
                            <i
                              className="fa fa-envelope"
                              style={{ marginRight: 4 }}
                            />
                            {getContactEmail(selectedObj) ||
                              "No email available"}
                            &nbsp;&bull;&nbsp;
                            <i
                              className="fa fa-check-circle"
                              style={{ marginRight: 4 }}
                            />
                            Status:{" "}
                            {selectedObj.enrollmentStatus
                              ? "Complete"
                              : "Pending"}
                            {type === "partner" && (
                              <>
                                &nbsp;&bull;&nbsp;
                                <i
                                  className="fa fa-users"
                                  style={{ marginRight: 4 }}
                                />
                                {selectedObj.activeUsers || 0} active users
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="wf-assign-actions">
                        {type === "application" && (
                          <>
                            <button
                              className="btn-action-search"
                              onClick={() =>
                                handleTabOnSelect("addEditRecruiter")
                              }
                            >
                              Edit
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("contracts")}
                            >
                              Contracts
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("ach")}
                            >
                              ACH
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("insurance")}
                            >
                              Insurance
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => {
                                const idx = recruiters.findIndex(r => r.fuid === selectedObj.fuid);
                                handleViewRecruiterForm("Recruiter", idx, selectedObj);
                                handleTabOnSelect("onboardingForm");
                              }}
                            >
                              Onboarding Form
                            </button>
                          </>
                        )}
                        {type === "partner" && (
                          <>
                            <button
                              className="btn-action-search"
                              onClick={() => handleTabOnSelect("status")}
                            >
                              Activate/Deactivate
                            </button>
                            <button
                              className="btn-action-search"
                              onClick={handlePartnerPerformer}
                            >
                              Manage Users
                            </button>
                          </>
                        )}
                        <button
                          className="btn-action-search btn-danger-search"
                          onClick={handleResetSelection}
                          title="Clear selection"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="wf-table-scroll">
                    {/* <button className="btn btn-sm btn-link" onClick={handleResetSelection}>Reset Selection</button> */}
                    <table
                      className={`wf-table wf-table-modern table-striped ${type === "application"
                        ? "wf-table-application"
                        : "wf-table-partner"
                        }`}
                    >
                      <thead className="wf-thead">
                        <tr>
                          <th style={{ width: "25%" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span>Recruiter</span>
                              {selectedRecruiterId > 0 && (
                                <button
                                  type="button"
                                  className="wf-reset-selection"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleResetSelection();
                                  }}
                                  title="Clear selection"
                                  style={{ margin: 0, padding: "2px 6px", height: "20px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <i className="fa fa-refresh" style={{ fontSize: "10px" }} />
                                </button>
                              )}
                            </div>
                          </th>
                          {type !== "partner" && (
                            <th style={{ width: "25%" }}>Key Contact</th>
                          )}
                          <th
                            style={{
                              width: type === "partner" ? "35%" : "25%",
                            }}
                          >
                            Onboarding
                          </th>
                          <th
                            style={{
                              width:
                                type === "partner"
                                  ? "15%"
                                  : "25%",
                            }}
                          >
                            Status
                          </th>
                          {type === "partner" && (
                            <>
                              <th style={{ width: "10%" }}>Total Users</th>
                              <th style={{ width: "15%" }}>Activation</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          Array.from({
                            length: pageSize > 5 ? 5 : Number(pageSize) || 5,
                          }).map((_, i) => (
                            <tr
                              key={`recruiter-skel-${i}`}
                              className="skeleton-row"
                            >
                              <td style={{ width: "25%" }}>
                                <div className="skeleton-identity">
                                  <span
                                    className="skeleton-cell sk-avatar"
                                    style={{ animationDelay: `${i * 0.04}s` }}
                                  />
                                  <div className="skeleton-stack">
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-long"
                                      style={{ animationDelay: `${i * 0.07}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-short"
                                      style={{ animationDelay: `${i * 0.06}s` }}
                                    />
                                  </div>
                                </div>
                              </td>
                              {type !== "partner" && (
                                <td style={{ width: "25%" }}>
                                  <div className="skeleton-stack">
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.08}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-long"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                  </div>
                                </td>
                              )}
                              <td
                                style={{
                                  width: type === "partner" ? "35%" : "25%",
                                }}
                              >
                                <span
                                  className="skeleton-cell sk-long"
                                  style={{ animationDelay: `${i * 0.06}s` }}
                                />
                              </td>
                              <td
                                style={{
                                  width:
                                    type === "partner"
                                      ? "15%"
                                      : "25%",
                                }}
                              >
                                <span
                                  className="skeleton-cell sk-short"
                                  style={{ animationDelay: `${i * 0.04}s` }}
                                />
                              </td>
                              {type === "partner" && (
                                <>
                                  <td style={{ width: "10%" }}>
                                    <span
                                      className="skeleton-cell sk-short"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.07}s` }}
                                    />
                                  </td>
                                </>
                              )}
                            </tr>
                          ))
                        ) : recruiters.length === 0 ? (
                          <tr>
                            <td colSpan={type === "partner" ? 5 : 4} style={{ padding: 0 }}>
                              <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                  <i
                                    className={
                                      dataType === "filter"
                                        ? "fa fa-search"
                                        : "fa fa-list-alt"
                                    }
                                  />
                                </div>
                                <p className="wf-empty-title">
                                  {dataType === "filter"
                                    ? "No Matching Recruiters"
                                    : "No Recruiters Found"}
                                </p>
                                <p className="wf-empty-desc">
                                  {dataType === "filter"
                                    ? "Try adjusting or resetting the filters to see recruiters."
                                    : "There are no recruiters available yet. Once created, they will appear here."}
                                </p>
                                {dataType === "filter" && (
                                  <button
                                    className="btn-action-search"
                                    onClick={() => handleFilterCancel("refresh")}
                                    style={{ marginTop: 4 }}
                                  >
                                    <i className="fa fa-refresh" />
                                    Reset Filters
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ) : (
                          recruiters.map((item, key) => (
                            <React.Fragment key={item.fuid || key}>
                              <tr
                                className={`wf-table-row ${selectedRecruiterId === item.fuid ? "selected-row" : ""} ${(selectedKey !== key && selectedKey !== -1) || (selectedFormKey !== key && selectedFormKey !== -1) ? "d-none" : ""}`}
                                onClick={() => handleSelectRecruiter(item)}
                                title={selectedRecruiterId === item.fuid ? `Click to deselect: ${item.label || "Recruiter"}` : `Click to select: ${item.label || "Recruiter"}`}
                              >
                                 <td style={{ width: "25%" }}>
                                   <div className="wf-identity-cell">
                                     <div className="wf-avatar-stack" style={{ position: "relative" }}>
                                       <KeyContactAvatar contact={item.contact1} />
                                       {selectedRecruiterId === item.fuid && (
                                         <div className="wf-avatar-check-badge">
                                           <i className="fa fa-check" />
                                         </div>
                                       )}
                                       <span className="wf-inline-id">#{item.fuid}</span>
                                     </div>
                                     <div className="wf-identity-copy">
                                       <div className="wf-identity-heading">
                                         <button
                                           type="button"
                                           onClick={(event) => {
                                             event.stopPropagation();
                                             handleSelectRecruiter(item, true);
                                             handleViewRecruiterForm("Recruiter", key, item);
                                             handleTabOnSelect("onboardingForm");
                                           }}
                                           className="btn p-0 btn-link btn-sm text-uppercase wf-identity-title wf-subcontractor-name-link"
                                         >
                                           {item.label || "Recruiter"}
                                         </button>
                                       </div>
                                       <div className="wf-identity-meta-row">
                                         <div className="wf-identity-meta-icon wf-icon-email">
                                           <i className="fa fa-envelope-o" />
                                         </div>
                                         <span className="wf-identity-meta-text">
                                           {getContactEmail(item) || "No email available"}
                                         </span>
                                       </div>
                                       {item.createdDate && (
                                         <div className="wf-identity-meta-row">
                                           <div className="wf-identity-meta-icon wf-icon-calendar">
                                             <i className="fa fa-calendar-o" />
                                           </div>
                                           <span className="wf-identity-meta-text">
                                             <Moment format="MMM Do YYYY">
                                               {item.createdDate}
                                             </Moment>
                                           </span>
                                         </div>
                                       )}
                                       {(item.accessKey || item.portalUrl || item.city || item.state || item.zip) && (
                                         <div className="wf-identity-meta-row">
                                           <div className="wf-identity-meta-icon wf-icon-address">
                                             <i className="fa fa-map-marker" />
                                           </div>
                                           <span className="wf-identity-meta-text wf-identity-address-text">
                                             {getAddressLines(item).map((line, lineIndex) => (
                                               <span key={lineIndex}>{line}</span>
                                             ))}
                                           </span>
                                         </div>
                                       )}
                                     </div>
                                   </div>
                                 </td>

                                 {type !== "partner" && (
                                   <td style={{ width: "25%" }}>
                                     {item.contact1 !== null ? (
                                       <div className="wf-contact-card">
                                         <div className="wf-identity-meta-row">
                                           <div className="wf-identity-meta-icon wf-icon-user">
                                             <i className="fa fa-user-circle-o" />
                                           </div>
                                           <span className="wf-contact-name">
                                             {getContactName(item.contact1)}
                                           </span>
                                         </div>
                                         <div className="wf-identity-meta-row">
                                           <span>
                                             {item.contact1.performeremail || "No email available"}
                                           </span>
                                         </div>
                                         {item.contact1?.contactNo && (
                                           <div className="wf-identity-meta-row">
                                             <div className="wf-identity-meta-icon wf-icon-phone">
                                               <i className="fa fa-phone" />
                                             </div>
                                             <span>
                                               {getFormatedNumber(item.contact1.contactNo)}
                                             </span>
                                           </div>
                                         )}
                                       </div>
                                     ) : (
                                       <span className="wf-muted-text">No contact assigned</span>
                                     )}
                                   </td>
                                 )}

                                  <td
                                    style={{
                                      width: type === "partner" ? "35%" : "25%",
                                      textAlign: "left",
                                      verticalAlign: "top",
                                    }}
                                    onClick={(event) => event.stopPropagation()}
                                  >
                                    <div
                                      className="wf-app-list"
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        textAlign: "left",
                                        justifyContent: "flex-start",
                                        gap: "10px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                      }}
                                    >
                                     {item.applications?.length > 0 ? (
                                       item.applications.map((app) => (
                                         <React.Fragment key={app.applicationId}>
                                           {type === "partner" && (
                                             <button
                                               type="button"
                                               className="wf-subcontractor-link-btn is-partner-app-link btn btn-sm btn-link p-0 text-left"
                                               onClick={() => {
                                                 handlePartnerApplication(item, app);
                                               }}
                                               title="Open application review"
                                               style={{ alignSelf: "flex-start", textAlign: "left" }}
                                             >
                                               {app.applicationId} - {app.applicationType || "Recruiter Application"}
                                             </button>
                                           )}

                                           {type === "application" && (
                                             <div className="wf-app-actions-card">
                                               <div
                                                 className="wf-action-stack"
                                                 style={{
                                                   display: "flex",
                                                   flexDirection: "column",
                                                   gap: "3px",
                                                   alignItems: "flex-start",
                                                   textAlign: "left",
                                                 }}
                                               >
                                                 {/* Row 1: Application Link */}
                                                 <button
                                                   type="button"
                                                   className="wf-subcontractor-link-btn is-app-title btn btn-sm btn-link p-0 text-left"
                                                   onClick={() =>
                                                     handlePartnerApplication(item, app)
                                                   }
                                                   title="Open application review"
                                                   style={{ alignSelf: "flex-start", textAlign: "left" }}
                                                 >
                                                   {app.applicationId} - {app.applicationType || "Recruiter Application"}
                                                 </button>

                                                 {/* Row 2: Remaining action link buttons */}
                                                 <button
                                                   type="button"
                                                   className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                                   onClick={() => {
                                                     handleSelectRecruiter(item, true);
                                                     handleViewRecruiterForm("Recruiter", key, item);
                                                     handleTabOnSelect("onboardingForm");
                                                   }}
                                                   title="Recruiter Onboarding Form"
                                                   style={{ alignSelf: "flex-start", textAlign: "left" }}
                                                 >
                                                   Onboarding Form
                                                 </button>

                                                 <button
                                                   type="button"
                                                   className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                                   onClick={() => {
                                                     handleSelectRecruiter(item, true);
                                                     handleDocumentViewShowHide("Document", key, app);
                                                     handleTabOnSelect("contracts");
                                                   }}
                                                   title="Contract Documents"
                                                   style={{ alignSelf: "flex-start", textAlign: "left" }}
                                                 >
                                                   Contract Documents
                                                 </button>

                                                 <button
                                                   type="button"
                                                   className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                                   onClick={() => {
                                                     handleSelectRecruiter(item, true);
                                                     handleACHShowHide("ACH", "Recruiter", item, key, app);
                                                     handleTabOnSelect("ach");
                                                   }}
                                                   title="ACH Information"
                                                   style={{ alignSelf: "flex-start", textAlign: "left" }}
                                                 >
                                                   ACH Information
                                                   {app?.achRequest > 0 && (
                                                     <span className="badge badge-pill badge-danger ml-1">
                                                       {app.achRequest}
                                                     </span>
                                                   )}
                                                 </button>

                                                 <button
                                                   type="button"
                                                   className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                                   onClick={() => {
                                                     handleSelectRecruiter(item, true);
                                                     handleInsuranceShowHide("Insurance", "Recruiter", item, key, app);
                                                     handleTabOnSelect("insurance");
                                                   }}
                                                   title="Insurance Information"
                                                   style={{ alignSelf: "flex-start", textAlign: "left" }}
                                                 >
                                                   Insurance Information
                                                   {app?.insuranceRequest > 0 && (
                                                     <span className="badge badge-pill badge-danger ml-1">
                                                       {app.insuranceRequest}
                                                     </span>
                                                   )}
                                                 </button>
                                               </div>
                                             </div>
                                           )}
                                         </React.Fragment>
                                       ))
                                     ) : (
                                       <span className="wf-muted-text" style={{ textAlign: "left", alignSelf: "flex-start" }}>
                                         No applications
                                       </span>
                                     )}
                                   </div>
                                 </td>

                                 <td style={{ width: type === "partner" ? "15%" : "25%" }}>
                                   <div className="wf-status-stack" style={{ alignItems: "flex-start" }}>
                                     {item.applications?.length > 0 ? (
                                       item.applications.map((app) => (
                                         <span
                                           key={`recruiter-ob-status-${app.applicationId}`}
                                           className={`wf-app-status-badge ${app.appSubmitted ? "is-complete" : "is-review"}`}
                                           style={{ minWidth: "78px", width: "auto", padding: "0 10px", whiteSpace: "nowrap", justifyContent: "center", cursor: "pointer" }}
                                           onClick={() => handlePartnerApplication(item, app)}
                                           title={app.appSubmitted ? "View Completed Application" : "Review Application"}
                                         >
                                           {app.appSubmitted ? "Complete" : "Review"}
                                         </span>
                                       ))
                                     ) : (
                                       <span
                                         className={`wf-status-pill ${item.enrollmentStatus ? "is-complete" : "is-pending"}`}
                                       >
                                         <i
                                           className={`fa ${item.enrollmentStatus ? "fa-check-circle" : "fa-clock-o"}`}
                                         />
                                         {item.enrollmentStatus ? "Complete" : "Pending"}
                                       </span>
                                     )}
                                   </div>
                                   {item.contact1 !== null &&
                                     type === "partner" &&
                                     !item.enrollmentStatus && (
                                       <div
                                         className="wf-row-actions mt-2"
                                         onClick={(event) =>
                                           event.stopPropagation()
                                         }
                                       >
                                         <button
                                           type="button"
                                           className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                           onClick={() =>
                                             handleRemainder(
                                               item.contact1.performerid,
                                             )
                                           }
                                           title="Send Reminder"
                                         >
                                           <i className="fa fa-bell-o mr-1" />
                                           Reminder
                                         </button>{" "}
                                         <button
                                           type="button"
                                           className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                           title="View message"
                                           onClick={handleRemainderMessage}
                                         >
                                           <i className="fa fa-envelope-o mr-1" />
                                           {!item.contact1?.msgAlertCount
                                             ? 0
                                             : item.contact1.msgAlertCount}
                                         </button>
                                       </div>
                                     )}
                                 </td>
                                 {type === "partner" && (
                                   <>
                                     <td style={{ width: "10%" }}>
                                       <span className="wf-count-pill">
                                         <i className="fa fa-users" />
                                         {item.activeUsers || 0}
                                       </span>
                                     </td>
                                     <td
                                       style={{ width: "15%" }}
                                       onClick={(event) => event.stopPropagation()}
                                     >
                                       <div className="wf-activation-stack">
                                         <span
                                           className={`wf-status-pill ${getActivationStatus(item.contact1).className}`}
                                         >
                                           <i
                                             className={`fa ${getActivationStatus(item.contact1).icon}`}
                                           />
                                           {
                                             getActivationStatus(item.contact1)
                                               .label
                                           }
                                         </span>

                                         {item.contact1?.addedDateTime && (
                                           <div className="wf-identity-meta-row">
                                             <div className="wf-identity-meta-icon wf-icon-calendar">
                                               <i className="fa fa-calendar-o" />
                                             </div>
                                             <span className="wf-identity-meta-text">
                                               <Moment format="MMM Do YYYY">
                                                 {item.contact1.addedDateTime}
                                               </Moment>
                                             </span>
                                           </div>
                                         )}

                                         {item.contact1?.isActive !== null &&
                                           item.contact1?.performerid && (
                                             <button
                                               type="button"
                                               className="wf-subcontractor-link-btn btn btn-sm btn-link p-0 text-left"
                                               onClick={() =>
                                                 handleRemainder(
                                                   item.contact1.performerid,
                                                 )
                                               }
                                               style={{ alignSelf: "flex-start" }}
                                             >
                                               <i className="fa fa-paper-plane-o mr-1" />
                                               Resend activation
                                             </button>
                                           )}
                                       </div>
                                     </td>
                                   </>
                                 )}
                              </tr>

                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>

                    {!isLoading && recruiters.length > 0 && selectedKey === -1 && selectedFormKey === -1 && (
                      <div className="mt-3">
                        <Pagination
                          currentPage={currentPage}
                          pageSize={pageSize}
                          itemsCount={rowsCount}
                          onPageChange={handlePageChange}
                          startIndex={startIndex}
                          endIndex={endIndex}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {selectedTab === "addEditRecruiter" && type === "application" && (
                <div className="mt-3">
                  <EditPartner
                    selectedObj={selectedObj}
                    type="Recruiter"
                    handleAddEditRecruiter={handleAddEditRecruiter}
                    selectedTab={selectedTab}
                  />
                </div>
              )}

              {["contracts", "ach", "insurance"].includes(selectedTab) &&
                type === "application" && (
                  <div className="wf-tab-panel pt-2">
                    {!selectedApp || !selectedCurrentTask ? (
                      <div className="wf-empty-state">
                        <div className="wf-empty-icon">
                          <i
                            className={`fa ${selectedTab === "contracts"
                              ? "fa-file-text-o"
                              : selectedTab === "ach"
                                ? "fa-bank"
                                : "fa-shield"
                              }`}
                          />
                        </div>
                        <p className="wf-empty-title">No Recruiter Application Selected</p>
                        <p className="wf-empty-desc">
                          Select a recruiter application from the table to view{" "}
                          {selectedTab === "contracts" && "contract documents"}
                          {selectedTab === "ach" && "ACH information"}
                          {selectedTab === "insurance" && "insurance information"}.
                        </p>
                        <button
                          className="btn-action-search"
                          onClick={() => handleTabOnSelect("home")}
                          style={{ marginTop: 4 }}
                        >
                          <i className="fa fa-list-alt" />
                          Back to Recruiters
                        </button>
                      </div>
                    ) : (
                      <div style={{ border: "none", background: "transparent", padding: 0 }}>
                        {selectedTab === "contracts" && (
                          <Document
                            documents={appDocumentSelector}
                            workflowTask={selectedCurrentTask}
                            uploadType={"Recruiter"}
                            app={selectedApp}
                            item={selectedObj}
                            viewType={""}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}

                        {selectedTab === "ach" && (
                          <AchInformation
                            workflowTask={selectedCurrentTask}
                            app={selectedApp}
                            item={selectedObj}
                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                            viewType={"recruiterList"}
                            achType={"Recruiter"}
                            setSelectedApp={setSelectedApp}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}

                        {selectedTab === "insurance" && (
                          <InsuranseInformation
                            workflowTask={selectedCurrentTask}
                            app={selectedApp}
                            item={selectedObj}
                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                            viewType={"recruiterList"}
                            insuranceType={"Recruiter"}
                            setSelectedApp={setSelectedApp}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}

              {selectedTab === "onboardingForm" && type === "application" && (
                <div className="wf-tab-panel pt-2">
                  {!selectedObj ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-list-alt" />
                      </div>
                      <p className="wf-empty-title">Onboarding Form</p>
                      <p className="wf-empty-desc">
                        Select an onboarding form from the recruiter table to view details.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => {
                          handleCloseDocumentView();
                          setSelectedTab("home");
                        }}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back
                      </button>
                    </div>
                  ) : (
                    <div className="wf-onboarding-panel">
                      {/* Form Styles */}
                      <style>{`
                        .as-form-header {
                          display: flex !important;
                          align-items: flex-start !important;
                          justify-content: space-between !important;
                          flex-wrap: wrap !important;
                          gap: 18px !important;
                          padding: 22px 24px 18px !important;
                          background: #ffffff !important;
                          border-bottom: 1px solid #e2e8f0 !important;
                          border-radius: 0 !important;
                          position: relative !important;
                          overflow: hidden !important;
                        }
                        .as-form-header-left {
                          display: flex !important;
                          align-items: flex-start !important;
                          gap: 14px !important;
                          min-width: 260px !important;
                          flex: 1 1 360px !important;
                        }
                        .as-form-header-right {
                          display: flex !important;
                          align-items: center !important;
                          gap: 8px !important;
                          flex-wrap: wrap !important;
                          justify-content: flex-end !important;
                          margin-left: auto !important;
                          position: relative !important;
                          z-index: 1 !important;
                          flex-shrink: 0 !important;
                        }
                        .as-header-back-btn {
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          padding: 0 14px !important;
                          color: #1e293b !important;
                          font-size: 14px !important;
                          font-weight: 500 !important;
                          display: inline-flex !important;
                          align-items: center !important;
                          gap: 8px !important;
                          cursor: pointer !important;
                          transition: all 0.2s ease !important;
                          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                          outline: none !important;
                          height: 34px !important;
                          min-height: 34px !important;
                        }
                        .as-header-back-btn:hover {
                          background: #f8fafc !important;
                          border-color: #94a3b8 !important;
                          color: #1e293b !important;
                          transform: translateY(-1px) !important;
                        }
                        .as-header-back-btn i {
                          color: #1e293b !important;
                        }
                        .as-form-header-icon {
                          width: 42px !important;
                          height: 42px !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          color: #1e293b !important;
                          font-size: 18px !important;
                          flex-shrink: 0 !important;
                          box-shadow: none !important;
                        }
                        .as-form-header-text {
                          position: relative !important;
                          z-index: 1 !important;
                        }
                        .as-form-header-title {
                          color: #1e293b !important;
                          font-size: 18px !important;
                          font-weight: 500 !important;
                          margin: 0 !important;
                          line-height: 1.2 !important;
                        }
                        .as-form-header-sub {
                          color: #64748b !important;
                          font-size: 13px !important;
                          margin-top: 6px !important;
                          font-weight: 600 !important;
                          max-width: 620px !important;
                        }
                        .as-form-header-meta {
                          display: flex !important;
                          align-items: center !important;
                          gap: 7px !important;
                          flex-wrap: wrap !important;
                          margin-top: 10px !important;
                        }
                        .as-meta-pill {
                          display: inline-flex !important;
                          align-items: center !important;
                          gap: 5px !important;
                          padding: 3px 8px !important;
                          height: 24px !important;
                          min-height: 24px !important;
                          box-sizing: border-box !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          color: #0f172a !important;
                          font-size: 11px !important;
                          font-weight: 600 !important;
                          font-family: "Open Sans", sans-serif !important;
                          box-shadow: none !important;
                        }
                        .as-meta-pill i { font-size: 11px !important; }
                        .as-meta-pill.meta-id i { color: #334155 !important; }
                        .as-meta-pill.meta-person i { color: #6d28d9 !important; }
                        .as-meta-pill.meta-email i { color: #0369a1 !important; }
                        .as-meta-pill.meta-status-active i { color: #15803d !important; }
                        .as-meta-pill.meta-status-inactive i { color: #b91c1c !important; }
                        .as-meta-pill.meta-status-pending i { color: #b45309 !important; }
                        .as-meta-pill.meta-ciid i { color: #0f766e !important; }
                        .wf-onboarding-panel {
                          padding: 0 !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          overflow: hidden !important;
                          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04) !important;
                          background: #ffffff !important;
                          margin-top: 10px !important;
                        }
                        .wf-onboarding-panel .as-form-header {
                          margin: 0 !important;
                          border-radius: 0 !important;
                        }
                        .wf-onboarding-panel > .col-md-12.px-0 {
                          padding: 24px !important;
                          background: #ffffff !important;
                        }
                        .wf-onboarding-panel > .wf-loading-container {
                          padding: 32px 18px !important;
                          background: #ffffff !important;
                        }
                        .wf-onboarding-panel .form-control-label {
                          color: #1e293b !important;
                          font-weight: 500 !important;
                        }
                        .wf-onboarding-panel .form-control-label > i.fa,
                        .wf-onboarding-panel .wf-input-icon {
                          display: none !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control,
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control,
                        .wf-onboarding-panel .wf-input-wrap > .form-control:not(textarea),
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:not(textarea),
                        .wf-onboarding-panel .form-control:not(textarea),
                        .wf-onboarding-panel select,
                        .wf-onboarding-panel input:not(textarea) {
                          height: 38px !important;
                          min-height: 38px !important;
                          max-height: 38px !important;
                          box-sizing: border-box !important;
                          line-height: normal !important;
                          padding: 0 12px !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          color: #1e293b !important;
                          font-size: 13.5px !important;
                          font-weight: 400 !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control:not(:disabled),
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:not(:disabled),
                        .wf-onboarding-panel .form-control:not(:disabled),
                        .wf-onboarding-panel select:not(:disabled),
                        .wf-onboarding-panel input:not(:disabled) {
                          background: #ffffff !important;
                          background-color: #ffffff !important;
                        }
                        .wf-onboarding-panel .form-control:disabled,
                        .wf-onboarding-panel .form-control[disabled],
                        .wf-onboarding-panel select:disabled,
                        .wf-onboarding-panel input:disabled,
                        .wf-onboarding-panel textarea:disabled {
                          background: #f8fafc !important;
                          background-color: #f8fafc !important;
                          color: #475569 !important;
                          -webkit-text-fill-color: #475569 !important;
                          border: 1px solid #cbd5e1 !important;
                          cursor: not-allowed !important;
                          opacity: 1 !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper {
                          height: 38px !important;
                          min-height: 38px !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper.disabled,
                        .wf-onboarding-panel .wf-merged-phone-wrapper.is-disabled,
                        .wf-onboarding-panel .wf-merged-phone-wrapper:has(:disabled) {
                          background: #f8fafc !important;
                          background-color: #f8fafc !important;
                          border: 1px solid #cbd5e1 !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-phone-input,
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-phone-input:disabled {
                          background: transparent !important;
                          background-color: transparent !important;
                          border: none !important;
                          box-shadow: none !important;
                          color: #475569 !important;
                          -webkit-text-fill-color: #475569 !important;
                          height: 100% !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-cc-trigger,
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-cc-trigger--disabled {
                          background: transparent !important;
                          background-color: transparent !important;
                          border: none !important;
                          box-shadow: none !important;
                          color: #475569 !important;
                          height: 100% !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control:focus,
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:focus,
                        .wf-onboarding-panel .form-control:focus,
                        .wf-onboarding-panel select:focus,
                        .wf-onboarding-panel input:focus {
                          border-color: #2563eb !important;
                          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
                        }
                        .wf-onboarding-panel button,
                        .wf-onboarding-panel .btn,
                        .wf-onboarding-panel .wf-btn,
                        .wf-onboarding-panel .card {
                          border-radius: 0 !important;
                        }
                      `}</style>

                      {/* Form Header */}
                      <div className="as-form-header mb-4">
                        <div className="as-form-header-left">
                          <div className="as-form-header-icon">
                            <i className="fa fa-pencil-square-o" />
                          </div>
                          <div className="as-form-header-text">
                            <p className="as-form-header-title">
                              Recruiter Onboarding Form
                            </p>
                            <div className="as-form-header-meta">
                              <span className="as-meta-pill meta-id">
                                <i className="fa fa-id-badge" /> ID: {selectedObj?.fuid || "New"}
                              </span>
                              {selectedObj?.label && (
                                <span className="as-meta-pill meta-person">
                                  <i className="fa fa-user" /> {selectedObj.label}
                                </span>
                              )}
                              {selectedObj?.email && (
                                <span className="as-meta-pill meta-email">
                                  <i className="fa fa-envelope-o" /> {selectedObj.email}
                                </span>
                              )}
                              {wfTask?.ciid > 0 && (
                                <span className="as-meta-pill meta-ciid">
                                  <i className="fa fa-hashtag" /> CIID: {wfTask.ciid}
                                </span>
                              )}
                              <span className={`as-meta-pill ${selectedObj?.contact1?.isActive === true ? 'meta-status-active' : selectedObj?.contact1?.isActive === false ? 'meta-status-inactive' : 'meta-status-pending'}`}>
                                <i className="fa fa-info-circle" /> Status: {
                                  selectedObj?.contact1?.isActive === true
                                    ? "Active"
                                    : selectedObj?.contact1?.isActive === false
                                      ? "Inactive"
                                      : "Pending Activation"
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="as-form-header-right">
                          <button
                            className="as-header-back-btn"
                            onClick={() => {
                              handleCloseDocumentView();
                              setSelectedTab("home");
                            }}
                          >
                            <i className="fa fa-arrow-left"></i> Back
                          </button>
                        </div>
                      </div>

                      {wfForm ? (
                        <div className="col-md-12 px-0">
                          <WorkflowElement
                            wfTask={wfTask}
                            wfForm={wfForm}
                            handleNextTask={() => {}}
                            viewType={true}
                            appSummary={false}
                            codeVerified={true}
                            wfTaskType={"form"}
                            updatedStateData={updatedStateData}
                          />
                        </div>
                      ) : (
                        <div className="wf-loading-container" style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "60px 20px",
                          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
                          margin: "20px auto",
                          maxWidth: "480px"
                        }}>
                          <div className="wf-loader-spinner" style={{
                            position: "relative",
                            width: "64px",
                            height: "64px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}>
                            <div className="spinner-double-ring" style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              border: "4px solid transparent",
                              borderTopColor: "#0f766e",
                              borderBottomColor: "#0f766e",
                              borderRadius: "50%",
                              animation: "spin 1.5s linear infinite"
                            }} />
                            <div className="spinner-inner-ring" style={{
                              position: "absolute",
                              width: "70%",
                              height: "70%",
                              border: "3px solid transparent",
                              borderLeftColor: "#2563eb",
                              borderRightColor: "#2563eb",
                              borderRadius: "50%",
                              animation: "spin-reverse 1.2s linear infinite"
                            }} />
                            <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
                          </div>

                          <p style={{
                            margin: "20px 0 6px 0",
                            color: "#0f172a",
                            fontSize: "15px",
                            fontWeight: 600,
                            letterSpacing: "-0.01em"
                          }}>
                            Fetching Onboarding Schema
                          </p>
                          <p style={{
                            margin: 0,
                            color: "#64748b",
                            fontSize: "12.5px",
                            fontWeight: 600,
                            textAlign: "center"
                          }}>
                            Please wait while we retrieve the Recruiter onboarding form details.
                          </p>

                          <div style={{
                            width: "120px",
                            height: "3px",
                            background: "#e2e8f0",
                            borderRadius: "2px",
                            marginTop: "16px",
                            overflow: "hidden",
                            position: "relative"
                          }}>
                            <div style={{
                              position: "absolute",
                              height: "100%",
                              width: "40%",
                              background: "linear-gradient(90deg, #0f766e, #2563eb)",
                              borderRadius: "2px",
                              animation: "pulse-loader 1.5s infinite ease-in-out"
                            }} />
                          </div>

                          <style dangerouslySetInnerHTML={{
                            __html: `
                            @keyframes spin {
                              0% { transform: rotate(0deg); }
                              100% { transform: rotate(360deg); }
                            }
                            @keyframes spin-reverse {
                              0% { transform: rotate(360deg); }
                              100% { transform: rotate(0deg); }
                            }
                            @keyframes pulse-loader {
                              0% { left: -40%; }
                              50% { left: 100%; }
                              100% { left: -40%; }
                            }
                          `}} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {selectedTab === "status" && type === "partner" && (
                <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                  {selectedRecruiterId === 0 && (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-toggle-on" />
                      </div>
                      <p className="wf-empty-title">No Recruiter Selected</p>
                      <p className="wf-empty-desc">
                        Select a recruiter from the table to manage activation.
                      </p>
                    </div>
                  )}
                  {selectedRecruiterId > 0 && (
                    <ActiveDeactiveHistory
                      selectedObj={selectedObj}
                      type="partner"
                      typeName="Recruiter"
                      actionType={actionType}
                      handlePermissionShowHide2={handlePermissionShowHide2}
                    />
                  )}
                </div>
              )}

              {selectedTab === "users" && selectedRecruiterId === 0 && (
                <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-user-plus" />
                    </div>
                    <p className="wf-empty-title">No Recruiter Selected</p>
                    <p className="wf-empty-desc">
                      Select a recruiter from the table to assign or manage users.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>



      {remainderMsgShowHide &&
        <ReminderAlertMessage
          remainderMsgShowHide={remainderMsgShowHide}
          handleRemainderMessage={handleRemainderMessage}
        ></ReminderAlertMessage>}

    </React.Fragment>
  );
}
